import React from 'react';

/** Small floating legend chip overlaid on a floorplan canvas.
 *  Explains the three pin colours at a glance: Outstanding, Rejected, Completed.
 *  Sized for mobile (compact) but readable on desktop.
 */
export default function PinLegend({ position = 'bottom-right', testId = 'pin-legend' }) {
    const positionClass = {
        'top-left': 'top-2 left-2',
        'top-right': 'top-2 right-2',
        'bottom-left': 'bottom-2 left-2',
        'bottom-right': 'bottom-2 right-2',
    }[position] || 'bottom-2 right-2';

    return (
        <div
            data-testid={testId}
            className={`absolute ${positionClass} z-30 bg-white/95 backdrop-blur-sm border border-[#18181B] px-2 py-1.5 shadow-sm pointer-events-none flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.14em] text-[#09090B]`}
        >
            <span className="inline-flex items-center gap-1">
                <span aria-hidden className="w-2.5 h-2.5 rounded-full bg-[#1FA5CF]" />
                Outstanding
            </span>
            <span className="text-[#A1A1AA]" aria-hidden>·</span>
            <span className="inline-flex items-center gap-1">
                <span aria-hidden className="w-2.5 h-2.5 rounded-full bg-[#E53935]" />
                Rejected
            </span>
            <span className="text-[#A1A1AA]" aria-hidden>·</span>
            <span className="inline-flex items-center gap-1">
                <span aria-hidden className="w-2.5 h-2.5 rounded-full bg-[#00875A]" />
                Completed
            </span>
        </div>
    );
}
